<template>
  <el-card class="box-card">
    <el-form ref="formInfo" class="global-form2" :model="formInfo"  label-width="120px">
      <el-form-item label="供应商名称" prop="supplierName">
          {{formInfo.supplierName}}
      </el-form-item>
      <el-form-item label="供应商类型" prop="supplierTypeName">
          {{formInfo.supplierTypeName}}
      </el-form-item>
      <el-form-item label="供应商级别" prop="supplierLevel">
          {{formInfo.supplierLevel}}
      </el-form-item>
      <el-form-item label="通讯邮编" prop="supplierPostal">
          {{formInfo.supplierPostal}}
      </el-form-item>
      <el-form-item label="地址" prop="area">
          {{formInfo.province}}{{formInfo.city}}{{formInfo.area}}{{formInfo.address}}
      </el-form-item>
      <el-form-item label="经营范围" prop="operationScope">
          {{formInfo.operationScope}}
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contactName">
          {{formInfo.contactName}}
      </el-form-item>
      <el-form-item label="联系人电话" prop="contactMobile">
          {{formInfo.contactMobile}}
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'SuppliermanageList',
  data () {
    return {
      formInfo: {},
      typeList: [],
      loading: false
    }
  },
  computed: {
    supplierId () {
      return this.$route.query.supplierId || ''
    }
  },
  created () {
    this.supplierId && this.getDetail()
  },
  methods: {
    getDetail () {
      this.loading = true
      this.$axios.get(this.$apis.system.selectYhSupplierBySupplierId, {
        supplierId: this.supplierId
      }).then((res) => {
        this.formInfo = res || {}
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .title {
    text-align: left;
    margin-bottom: 25px;
    font-weight: bold;
    font-size: 14px;
  }
</style>
